function openCustomPopup() {
  document.querySelector('.custom-size-popup').style.display = 'flex';
}

function closeCustomPopup() {
  document.querySelector('.custom-size-popup').style.display = 'none';
}

function submitCustomOrder() {
  const submitBtn = document.getElementById('custom-submit-btn');
  const originalText = submitBtn.innerHTML;

  submitBtn.disabled = true;
  submitBtn.innerHTML = 'ADDING...';
  document.querySelectorAll('.form-field').forEach(field => {
    field.classList.remove('error');
    const errorMsg = field.querySelector('.error-message');
    if (errorMsg) errorMsg.remove();
  });

  const variantIdInput = document.querySelector('input[name="id"].product-variant-id');
  const variantId = variantIdInput ? variantIdInput.value : null;

  if (!variantId) {
    alert('Variant ID not found!');
    submitBtn.disabled = false;
    submitBtn.innerHTML = originalText;
    return;
  }

  const formData = {
    items: [{
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: {}
    }]
  };

  let isValid = true;
  let firstInvalidInput = null;

  document.querySelectorAll('.custom-form-grid input, .custom-form-grid textarea').forEach(input => {
    const fieldWrapper = input.closest('.form-field');
    const fieldName = input.name.replace('properties[', '').replace(']', '');
    const value = input.value.trim();
    const isSpecial = fieldName.toLowerCase().includes('special');

    // Validate empty
    if (!value && !isSpecial) {
      isValid = false;
      if (!firstInvalidInput) firstInvalidInput = input;
      showFieldError(fieldWrapper, 'This field is required');
      return;
    }

    // Validate (input)
    if (input.tagName.toLowerCase() === 'input' && value) {
      const numericValue = parseFloat(value);
      if (isNaN(numericValue) || numericValue <= 0) {
        isValid = false;
        if (!firstInvalidInput) firstInvalidInput = input;
        showFieldError(fieldWrapper, 'Enter a valid positive number');
        return;
      }
    }

    // Đưa vào properties nếu hợp lệ
    if (value) {
      formData.items[0].properties[fieldName] = value;
    }
  });

  if (!isValid) {
    if (firstInvalidInput) firstInvalidInput.focus();
    submitBtn.disabled = false;
    submitBtn.innerHTML = originalText;
    return;
  }

  // Submit if true
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(res => {
      if (res.ok) {
        const pathParts = window.location.pathname.split('/');
        const currentLocalePrefix = pathParts[1];
        const isLocalePath = /^[a-z]{2}-[a-z]{2}$/.test(currentLocalePrefix);

        const cartUrl = isLocalePath ? `/${currentLocalePrefix}/cart` : '/cart';
        window.location.href = cartUrl;
      } else {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        alert('Failed to add to cart');
      }
    })
    .catch(err => {
      console.error(err);
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalText;
      alert('Something went wrong');
    });
}

function showFieldError(wrapper, message) {
  wrapper.classList.add('error');
  const errorDiv = document.createElement('div');
  errorDiv.className = 'error-message';
  errorDiv.style.color = 'red';
  errorDiv.style.fontSize = '12px';
  errorDiv.style.marginTop = '4px';
  errorDiv.textContent = message;
  wrapper.appendChild(errorDiv);
}
